import { render, staticRenderFns } from "./ReplacementPreview.vue?vue&type=template&id=604839ab&scoped=true&"
import script from "./ReplacementPreview.vue?vue&type=script&lang=js&"
export * from "./ReplacementPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementPreview.vue?vue&type=style&index=0&id=604839ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604839ab",
  null
  
)

export default component.exports